<script setup>
import { RouterView } from 'vue-router'
import LoadingBackdrop from './components/utils/LoadingBackdrop.vue'
import { useAuthStore } from './stores/authStore'
import { computed } from 'vue'

const authStore = useAuthStore()
const loading = computed(
  () => authStore.isCheckingUserStatus || authStore.isHandlingCustomClaims,
)
</script>

<template>
  <LoadingBackdrop v-if="loading" v-model="loading" />
  <RouterView />
</template>
